export default "__VITE_ASSET__Bj_M0AZr__"